module.exports = __webpack_public_path__ + "img/home-bg.a9461aba.jpg";